export const PAYMENT = {
    SUCCESS: 'success',
    FAIL: 'fail',
}

export const PAYMENT_METHOD = {
    PG: "PG",
    TS_WALLET: "TSWALLET"
}